import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';

import { ZendeskLinkModule } from '@libs/src/zendesk-link/zendesk-link.module';
import { ActionQueueModule } from '@main-client/src/app/members/automated-user-management/action-queue/action-queue.module';
import { AutomatedUserManagementBannerModule } from '@main-client/src/app/members/automated-user-management/banner/banner.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';
import { UploadCsvButtonModule } from '@main-client/src/app/upload-csv-button/upload-csv-button.module';

import { CSVUploadViewComponent } from './csv-upload.component';
import { ActionQueueComponent } from '@main-client/src/app/members/automated-user-management/action-queue/action-queue.component';

import { CsvAttributeMappingsModule } from '../csv-attribute-mappings/csv-attribute-mappings.module';

@NgModule({
  declarations: [CSVUploadViewComponent],
  exports: [CSVUploadViewComponent],
  imports: [
    ActionQueueModule,
    AutomatedUserManagementBannerModule,
    CommonModule,
    CsvAttributeMappingsModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    NzBreadCrumbModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    NzSpinModule,
    NzStepsModule,
    ProgressSpinnerModule,
    RouterModule.forChild([
      {
        component: ActionQueueComponent,
        path: 'review',
      },
    ]),
    UploadCsvButtonModule,
    ZendeskLinkModule,
  ],
})
export class CSVUploadModule {}
